module.exports = __webpack_public_path__ + "img/1-4.eb54b77f.svg";